import { useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";

import { Editor } from "@craftjs/core";
import { AppContainer } from "twyne-new.ui";

import { useDefaultTailwindConfig } from "@/components/builder/utils/tailwindConfig/hooks";
import BuilderContent from "@/modules/cms/views/post/components/builder/Content/Builder";
import Header from "@/modules/cms/views/post/components/builder/Content/Header";
import LeftSidebar from "@/modules/cms/views/post/components/builder/Content/LeftSidebar";
import RightSidebar from "@/modules/cms/views/post/components/builder/Content/RightSidebar";
import Sidebar from "@/modules/cms/views/post/components/builder/Content/Sidebar";
import { BuilderProvider, useCraft, useEditing, useInteractionMode, useAutoSave } from "@/modules/cms/views/post/components/builder/context";
import useAutoSelectEditing from "@/modules/cms/views/post/components/builder/hooks/useAutoSelectEditing";
import useCompiler from "@/modules/cms/views/post/components/builder/hooks/useCompiler";
import { HistoryProvider } from "@/modules/cms/views/post/components/builder/hooks/useHistory";

import { BuilderStoreProvider, useBuilderStore } from "../builder/store";

function Content() {
  useAutoSelectEditing()
  useDefaultTailwindConfig()

  return <>
    <AppContainer direction='vertical'>
      <Header page={null} title={null} />
      <AppContainer className='gap-2 p-2' variant='none'>
        <LeftSidebar defaultValue='assets' pages={null} />
        <AppContainer direction='vertical' variant='none'>
          <BuilderContent />
        </AppContainer>
        <Sidebar size='96' open={true}>
          <RightSidebar />
        </Sidebar>
      </AppContainer>
    </AppContainer>
  </>
}

function Builder() {
  const { value: editing } = useEditing()
  const { value: interactionMode } = useInteractionMode()
  const { resolver } = useCompiler()
  const { setValue: setCraft, value: craft } = useCraft()
  const { id } = useParams()
  const { handleAutoSave } = useAutoSave()

  const { postBuilder: { useLoad: useLoadBuilder } } = useBuilderStore()
  useLoadBuilder(id)

  useEffect(() => {
    if (craft && editing) {
      editing.definition.craft = craft
      handleAutoSave({ craft })
    }
  }, [editing, craft, handleAutoSave])

  const handleChange = useCallback(query => {
    const craft = query.getSerializedNodes()
    setCraft(craft)
  }, [setCraft])

  return <Editor resolver={resolver} onNodesChange={handleChange} enabled={interactionMode !== 'select'}>
    <HistoryProvider>
      <Content />
    </HistoryProvider>
  </Editor>
}

export default function BuilderForm() {
  return <BuilderStoreProvider>
    <BuilderProvider>
      <Builder />
    </BuilderProvider>
  </BuilderStoreProvider>
}
